module.exports = __webpack_public_path__ + "img/firning1.7dbef617.jpg";